



















































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import UpdateWorkerPermPreviousExperienceRequest from '@/models/Workers/UpdateWorkerPermPreviousExperienceRequest';

@Component({
    name: 'WorkerPermPreviousExperienceEdit'
})
export default class extends GiganautVueDialog {

  public entity = new WorkerDto();
  public editorKey = 0;
  public editorReady = false;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }
  
  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateWorkerPermPreviousExperienceRequest();
    request.updatedAt = this.entity.updatedAt;
    request.previousExperience = this.entity.previousExperience;
    await WorkerDetailsModule.editPermPreviousExperience(request);
    this.dialog = false;
  }
}
